import React from "react";

function Adoption() {
  const blockchains = [
    { name: "Ethereum", img: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=035" },
    { name: "Hedera", img: "https://cryptologos.cc/logos/hedera-hbar-logo.svg?v=035" },
    { name: "NEAR", img: "https://cryptologos.cc/logos/near-protocol-near-logo.svg?v=035" },
    { name: "BNB Chain", img: "https://cryptologos.cc/logos/bnb-bnb-logo.svg?v=035" },
    { name: "Polygon", img: "https://cryptologos.cc/logos/polygon-matic-logo.svg?v=035" },
    { name: "Solana", img: "https://cryptologos.cc/logos/solana-sol-logo.svg?v=035" },
    { name: "Stellar", img: "https://cryptologos.cc/logos/stellar-xlm-logo.svg?v=035" },
  ];

  return (
    <>
      {/* CTA Banner */}
      <div style={{
        background: "linear-gradient(135deg, #0a1f44 0%, #1a365d 100%)",
        padding: "40px 0",
        textAlign: "center"
      }}>
        <div className="container d-flex flex-wrap justify-content-center align-items-center gap-4">
          <h4 className="fw-bold text-white mb-0" style={{ fontSize: "clamp(16px, 2vw, 22px)" }}>
            Use our script & quickly launch your crypto exchange 🚀
          </h4>
          <a href="#" className="btn" style={{
            background: "#3b82f6",
            color: "#fff",
            padding: "12px 30px",
            borderRadius: "30px",
            fontWeight: "700",
            textDecoration: "none"
          }}>
            Get Started
          </a>
        </div>
      </div>

      {/* Blockchain Platforms */}
      <div style={{ padding: "80px 0", background: "#f7f9fc" }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}>
              Blockchain Platforms We Work On
            </h2>
            <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
              We build crypto exchange solutions on all major blockchain networks to ensure maximum compatibility.
            </p>
          </div>
          <div className="d-flex flex-wrap justify-content-center gap-4">
            {blockchains.map((chain, idx) => (
              <div key={idx} className="ce-chain-card">
                <img src={chain.img} alt={chain.name} style={{ width: "48px", height: "48px" }} />
                <span className="fw-semibold" style={{ fontSize: "13px", color: "#334155" }}>{chain.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div style={{
        background: "linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)",
        padding: "50px 0",
        textAlign: "center",
        borderRadius: "20px",
        margin: "0 20px 60px"
      }}>
        <div className="container">
          <h3 className="fw-bold text-white mb-2" style={{ fontSize: "clamp(20px, 2.5vw, 30px)" }}>
            Looking for development or collaboration?
          </h3>
          <p className="text-white mb-4" style={{ opacity: 0.85, maxWidth: "500px", margin: "0 auto" }}>
            Unlock the full potential of blockchain technology and scale your business with Xeer Technology
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a href="#" className="btn" style={{
              background: "#fff",
              color: "#1e40af",
              padding: "14px 35px",
              borderRadius: "30px",
              fontWeight: "700",
              textDecoration: "none"
            }}>
              Talk to Expert
            </a>
            <a href="#" className="btn" style={{
              background: "transparent",
              color: "#fff",
              padding: "14px 35px",
              borderRadius: "30px",
              fontWeight: "700",
              border: "2px solid #fff",
              textDecoration: "none"
            }}>
              Talk to Sales
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Adoption;
